import { ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';

import {
  CmAccordionButton,
  CmAccordionItem,
  CmBox,
  CmButton,
  CmFlex,
  CmLabelAndSingleReactSelect,
  CmMiniPopover,
  CmText,
  ReactSingleSelectInput,
  SelectForm,
} from '@/components/uiParts';
import { LocalStorageHandler } from '@/lib/LocalStorageHandler';

import { TextIcon } from './TextIcon';

export type MenuManagementSingleSelectInput = ReactSingleSelectInput & {
  isDisabled?: boolean;
};

interface Props {
  icon: React.ReactNode;
  panel: React.ReactNode;
  isDisabled?: boolean;
  associateBrandSelectInput?: MenuManagementSingleSelectInput;
}

export const MenuManagementsAccordionItem: React.VFC<Props> = ({
  icon,
  panel,
  isDisabled,
  associateBrandSelectInput,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenPopover = () => setIsOpen(true);
  const handleClosePopover = () => setIsOpen(false);

  const handleChangeSelect = (value: SelectForm | null) => {
    if (associateBrandSelectInput === undefined) return;
    if (value === null) return;
    handleClosePopover();
    associateBrandSelectInput.onChange(value);
    LocalStorageHandler.set('menuManagement', { associateBrand: value });
  };

  const brandName = (() => {
    const { associateBrand } = LocalStorageHandler.get('menuManagement');
    if (associateBrand !== undefined) {
      // ローカルストレージの値もapiの値と一緒ではあるが、apiで取得をするまでチカチカするのでローカルストレージの値を使っている。
      return associateBrand.label;
    }
    if (associateBrandSelectInput === undefined) return;
    return associateBrandSelectInput.value?.label;
  })();

  return (
    <CmAccordionItem border="none" isDisabled={isDisabled}>
      {({ isExpanded }) => (
        <>
          <h2>
            <CmAccordionButton>
              <CmFlex
                w="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <TextIcon icon={icon} color="white">
                  メニュー管理
                </TextIcon>
                {isExpanded ? (
                  <ChevronDownIcon color="white" fontSize="28px" />
                ) : (
                  <ChevronLeftIcon color="white" fontSize="28px" />
                )}
              </CmFlex>
            </CmAccordionButton>
          </h2>
          {isExpanded && associateBrandSelectInput !== undefined && (
            <CmBox
              h="100%"
              display="flex"
              alignItems="center"
              cursor={isDisabled ? 'not-allowed' : 'pointer'}
              px={3}
              pt={1}
            >
              <CmMiniPopover
                {...{ isOpen }}
                placement="bottom-start"
                onOpen={handleOpenPopover}
                onClose={handleClosePopover}
                button={
                  // @ts-ignore TS2590
                  <CmButton
                    width="100%"
                    pr="4px"
                    justifyContent="space-between"
                    isDisabled={associateBrandSelectInput.isDisabled}
                    rightIcon={
                      isOpen ? (
                        <ChevronDownIcon color="white" fontSize="28px" />
                      ) : (
                        <ChevronLeftIcon color="white" fontSize="28px" />
                      )
                    }
                  >
                    <CmText isEllipsis>{brandName}</CmText>
                  </CmButton>
                }
              >
                <CmBox>
                  <CmLabelAndSingleReactSelect
                    label="ブランド選択"
                    name="brandName"
                    closeMenuOnSelect
                    isClearable={false}
                    singleSelectInput={{
                      ...associateBrandSelectInput,
                      onChange: (value) => {
                        associateBrandSelectInput.onChange(value);
                        handleChangeSelect(value);
                      },
                    }}
                  />
                </CmBox>
              </CmMiniPopover>
            </CmBox>
          )}
          {panel}
        </>
      )}
    </CmAccordionItem>
  );
};
